<template>
  <div id="overlay-info" v-show="showContent" v-on:click.self="closeModal">
    <div id="content-info" class="action-close">
      <about class="element"></about>
      <change-log class="element"></change-log>
      <fanbox-link class="element"></fanbox-link>
      <note class="element"></note>
      <div id="version">ver{{this.$appVersion}}</div>
      <button class="btn" v-on:click="closeModal">×</button>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import About from './info/About'
import ChangeLog from './info/ChangeLog'
import FanboxLink from './info/FanboxLink'
import Note from './info/Note'

export default {
  props: ['showContent'],
  methods: {
    closeModal: function () {
      this.offNewFlag()
      this.$emit('close')
    },
    ...mapActions(['offNewFlag'])
  },
  components: {
    About,
    ChangeLog,
    FanboxLink,
    Note
  }
}
</script>

<style scoped>
>>> p {
  margin: 2px;
}
#overlay-info {
  /* 要素を重ねた時の順番 */
  z-index:1;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.6);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;

}
#content-info {
  z-index:2;
  background-color: #F4EAE0;
  width: 800px;
  max-height: 640px;
  border: 2px solid;
  border-image: linear-gradient(to top, #877325, #C0B578);
  border-image-slice:1;
  text-align: left;
}
#fanbox-link {

}
#note {
}
#version {
  text-align: right;
}
.btn {
  color: #FFFFFF;
  font-size: 20pt;
  background-color: #393836;
  padding: .3em .5em;
  text-align: center;
  cursor: pointer;
}
.btn:hover {
  cursor: pointer;
}
/* close button */
.action-close {
  position: relative;
  margin-top: 2em;
}
.action-close .btn {
  position: absolute;
  right: 0;
  top: -1em;
}
.element {
  padding-left: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/InfoModalSm.vue